import React, { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Dispatch } from 'redux';
import {
    endpoints,
    environmentSelector,
    fetchAppControllerInfo,
    useAppDispatch,
    useAppSelector,
    SideNavContainer,
    PAGE_TYPE,
} from '../utils';

const capApplications = () => {
    const dispatch: Dispatch<any> = useAppDispatch();
    const environment = useAppSelector(environmentSelector);
    const { id } = useParams();
    const encHouseHoldId = id;

    useEffect(() => {
        dispatch(
            fetchAppControllerInfo(
                endpoints.MEMBER_APP_LIST_CONTROLLER.processReplacements({
                    encHouseHoldId,
                }),
                environment,
            ),
        );
    }, [id, encHouseHoldId]);

    return (
        <SideNavContainer page={PAGE_TYPE.APPLICATION_ELIGIBILITY_PAGE}>
            <Outlet/>
        </SideNavContainer>
    );
};

export default capApplications;
